import classNames from 'classnames';
import React from 'react';
import { getEmptyImage } from 'react-dnd-html5-backend';
import DocumentThumbnail from 'components/DocumentThumbnail';
import Icon from 'components/Icon';
import { IconType } from 'components/Icon/constants';
import { GroupLayoutDocumentMap, ReusableLayoutMap } from 'models/entities';
import styles from './styles.module.scss';
import { useLayoutListItemRenditionDragSource } from './useLayoutListItemRenditionDragSource';

type Props = {
  document: ReusableLayoutMap | GroupLayoutDocumentMap;
  dataTestId?: string;
};

const LayoutListItemRendition: React.FC<Props> = (props) => {
  const { document, dataTestId = 'layoutListItemRendition' } = props;

  const { isDragging, dragRef, preview } = useLayoutListItemRenditionDragSource({ component: document });

  React.useEffect(() => { preview(getEmptyImage(), { captureDraggingState: true }); }, [preview]);

  return (
    <div className={styles.LayoutListItemRendition}>
      <div className={styles.label} data-testid={`${dataTestId}-label`}>Low rendition</div>
      {dragRef(
        <div
          className={classNames(styles.rendition, {
            [styles.dragging]: isDragging,
          })}
          data-testid={dataTestId}
        >
          <Icon className={styles.layoutRenditionMarker} type={IconType.MOVE} size="badge" color="secondary" />
          <DocumentThumbnail
            placeholder={<Icon type={IconType.IMAGE} size="sm" color="disabled"/>}
            url={document.get('_thumbnailUrl')}
            dataTestId={`${dataTestId}-thumbnail`}
          />
        </div>,
      )}
    </div>
  );
};

export default LayoutListItemRendition;
